import React from "react";

const PageNotFound = () => {
  return (
    <>
      <div class="flex flex-col h-screen justify-center items-center">
        <h1 className="text-6xl text-black">404 Error</h1>
        <h1 className="text-2xl text-black">Page Not Found</h1>
      </div>
    </>
  );
};

export default PageNotFound;
